import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { returnToPreviousMacroWizardPath, addEdgeToDecisionTreePath } from 'actions/searchActions';
import { handleError } from 'services/ErrorService/ErrorService';
import { getSelectedOrder, getFirstSelectedSubscription } from 'selectors/tools';
import {
  getChildrenOfCurrentDecisionNode,
  extractSelectedNonHistoricalTicketFromState,
  isSpecialist,
} from 'extractFromState';
import { ConfigurableNodeError } from '../../../../util';
import LoadingComponent, { LoadingWrapper } from '../../../LoadingComponent/LoadingComponent';

const DTConfigurableNodeView = (props) => {
  const { processHandler, nodeConfig } = props;
  const dispatch = useDispatch();
  const isUserSpecialist = useSelector(isSpecialist);
  const decisionNodeChildren = useSelector(getChildrenOfCurrentDecisionNode);
  const selectedOrder = useSelector(getSelectedOrder);
  const selectedSubscription = useSelector(getFirstSelectedSubscription);
  const [conditionMetEdge, conditionNotMetEdge] = useMemo(
    () => Object.keys(decisionNodeChildren),
    [decisionNodeChildren]
  );

  const ticket = useSelector(extractSelectedNonHistoricalTicketFromState);
  const ticketFieldsArray = ticket.moreTicketInfo?.ticketFields;
  const ticketFields = useMemo(() => {
    const mappedTicketFields = {};
    if (ticketFieldsArray) {
      for (const ticketField of ticketFieldsArray) {
        const { title, value } = ticketField;
        mappedTicketFields[title] = value;
      }
    }

    return mappedTicketFields;
  }, [ticketFieldsArray]);

  useEffect(() => {
    try {
      const conditionResult = processHandler(
        nodeConfig,
        ticketFields,
        selectedOrder,
        selectedSubscription,
        isUserSpecialist
      );
      if (conditionResult) {
        dispatch(addEdgeToDecisionTreePath(conditionMetEdge));
      } else {
        dispatch(addEdgeToDecisionTreePath(conditionNotMetEdge));
      }
    } catch (error) {
      dispatch(returnToPreviousMacroWizardPath());
      if (error instanceof ConfigurableNodeError) {
        if (error.cause) {
          // Only log to Sentry if we have an error with condition-logic causes.
          handleError({ error, customMessage: error.message, customFields: error.cause });
        }
        handleError({ error, customMessage: error.message, popupOnly: true });
      } else {
        handleError({ error, popupOnly: true });
      }
    }
  }, [
    dispatch,
    ticketFields,
    conditionNotMetEdge,
    conditionMetEdge,
    nodeConfig,
    selectedOrder,
    selectedSubscription,
    isUserSpecialist,
    processHandler,
  ]);

  return (
    <LoadingWrapper>
      <LoadingComponent />
    </LoadingWrapper>
  );
};

export default DTConfigurableNodeView;
